import axios from 'axios';

const API_URL = 'https://api.lazerzonearena.ca/api';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,  // Esto asegura que la cookie se envíe y reciba

});

// 🛠️ Interceptor para loggear cada request
api.interceptors.request.use(
  config => {
    console.log(`[API Request] ${config.method.toUpperCase()} ${config.url}`, config.data || '');
    return config;
  },
  error => {
    console.error('[API Request Error]', error);
    return Promise.reject(error);
  }
);

// 🛠️ Interceptor para loggear cada response
api.interceptors.response.use(
  response => {
    console.log(`[API Response] ${response.status} ${response.config.url}`, response.data);
    return response;
  },
  error => {
    console.error(
      '[API Response Error]',
      error.response?.status,
      error.response?.data || error.message
    );
    return Promise.reject(error);
  }
);
export const obtenerJuegos = async () => {
  try {
    const response = await api.get('/juegos', { params: { _cb: Date.now() } });
    return response.data;
  } catch (error) {
    console.error('Error al obtener los juegos:', error);
    throw error;
  }
};



// : Función para registrar usuario
export const registrarUsuario = async ({ name, username, email, password }) => {
  try {
    const response = await api.post('/auth/register', {
      name,
      username,
      email,
      password,
    });
    return response.data;
  } catch (error) {
    console.error('Error al registrar usuario:', error.response?.data?.message || error.message);
    throw error;
  }
};

// Función para hacer login (en el frontend)
export const signInWithEmailAndPassword = async ({ email, password }) => {
  try {
    const response = await api.post('/auth/login', {
      email,
      password,
    });
    return response.data;
  } catch (error) {
    console.error('Error al iniciar sesión:', error.response?.data?.message || error.message);
    throw error;
  }
};
// Función para iniciar sesión con usuario social
export const loginUsuarioSocial = async ({ correo, provider, uid }) => {
  try {
    const response = await api.post('/auth/login-social', {
      correo,
      provider,
      uid,  // Ahora se incluye el UID
    });
    return response.data;
  } catch (error) {
    console.error('Error al iniciar sesión con usuario social:', error.response?.data?.message || error.message);
    throw error;
  }
};


export const obtenerUsuarioAutenticado = async () => {
  try {
    const response = await api.get('/auth/me', { params: { _cb: Date.now() } });
    return response.data;
  } catch (error) {
    console.error('No se pudo obtener el usuario autenticado:', error.response?.data?.message || error.message);
    throw error;
  }
};
// Función para cerrar sesión (eliminar la cookie)
export const logoutUsuario = async () => {
  try {
    const response = await api.post('/auth/logout');
    return response.data;  // Esto puede incluir un mensaje confirmando el logout
  } catch (error) {
    console.error('Error al cerrar sesión:', error.response?.data?.message || error.message);
    throw error;
  }
};


// === ADMIN & ACCESS REQUEST ===

// Login administrador
export const loginUsuario = async ({ email, password }) => {
  try {
    const response = await api.post('/auth/admin/login', { email, password });
    return response.data;
  } catch (error) {
    console.error('Error en admin login:', error.response?.data?.message || error.message);
    throw error;
  }
};

// Solicitar acceso (registro de admin)
export const solicitarRegistro = async ({ name, email, password }) => {
  try {
    const response = await api.post('/admin/register-request', { name, email, password });
    return response.data;
  } catch (error) {
    console.error('Error al solicitar registro:', error.response?.data?.message || error.message);
    throw error;
  }
};

// Obtener solicitudes de admin (solo admin)
export const obtenerSolicitudesAdmin = async () => {
  try {
    const response = await api.get('/admin/requests');
    return response.data;
  } catch (error) {
    console.error('Error al obtener solicitudes de admin:', error.response?.data?.message || error.message);
    throw error;
  }
};

// Aprobar solicitud de admin	export 
const aprobarSolicitudAdmin = async (id) => {
  try {
    const response = await api.post(`/admin/requests/${id}/approve`);
    return response.data;
  } catch (error) {
    console.error('Error al aprobar solicitud:', error.response?.data?.message || error.message);
    throw error;
  }
};

// Rechazar solicitud de admin
export const rechazarSolicitudAdmin = async (id) => {
  try {
    const response = await api.post(`/admin/requests/${id}/reject`);
    return response.data;
  } catch (error) {
    console.error('Error al rechazar solicitud:', error.response?.data?.message || error.message);
    throw error;
  }
};

// === RESERVAS / BOOKINGS ===
export const obtenerHorasReservadas = async (fecha) => {
  try {
    const res = await api.get(`/reservas/horas`, {
      params: { fecha }
    });
    return res.data;
  } catch (err) {
    console.error('Error al obtener horas reservadas:', err);
    return [];
  }
};

export const crearReserva = async (reservaData) => {
  try {
    const response = await api.post('/reservas', reservaData);
    return response.data;
  } catch (error) {
    console.error('Error al crear la reserva:', error.response?.data?.message || error.message);
    throw error;
  }
};

// Obtener todas las bookings (solo admin)
export const obtenerBookings = async () => {
  try {
    const response = await api.get('/reservas');
    return response.data;
  } catch (error) {
    console.error('Error al obtener bookings:', error.response?.data?.message || error.message);
    throw error;
  }
};

// Obtener 1 booking por id (solo admin)
export const obtenerBookingById = async (id) => {
  try {
    const response = await api.get(`/reservas/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener booking por id:', error.response?.data?.message || error.message);
    throw error;
  }
};
export const actualizarEstadoReserva = async (id, nuevoEstado) => {
  try {
    const response = await api.patch(`/reservas/${id}/state`, { estado: nuevoEstado });
    return response.data;
  } catch (error) {
    console.error('Error al actualizar estado de la reserva:', error.response?.data?.message || error.message);
    throw error;
  }
};
export const obtenerJuegoPorId = async (id) => {
  try {
    const response = await api.get(`/juegos/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener el juego con ID ${id}:`, error.response?.data?.message || error.message);
    throw error;
  }
};
export const actualizarJuego = async (id, juegoData) => {
  try {
    const response = await api.put(`/juegos/${id}`, juegoData);
    return response.data;
  } catch (error) {
    console.error(`Error al actualizar el juego con ID ${id}:`, error.response?.data?.message || error.message);
    throw error;
  }
};
export const crearJuego = async (juegoData) => {
  try {
    const response = await api.post('/juegos', juegoData);
    return response.data;
  } catch (error) {
    console.error('Error al crear el juego:', error.response?.data?.message || error.message);
    throw error;
  }
};
export const eliminarJuego = async (id) => {
  try {
    const response = await api.delete(`/juegos/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error al eliminar el juego con ID ${id}:`, error.response?.data?.message || error.message);
    throw error;
  }
};

// Obtener todas las categorías
export const obtenerCategorias = async () => {
  try {
    const response = await api.get('/categories');
    return response.data;
  } catch (error) {
    console.error('Error al obtener las categorías:', error);
    throw error;
  }
};

// Obtener una categoría por ID
export const obtenerCategoriaPorId = async (id) => {
  try {
    const response = await api.get(`/categories/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener la categoría con ID ${id}:`, error.response?.data?.message || error.message);
    throw error;
  }
};

// Crear nueva categoría
export const crearCategoria = async (categoriaData) => {
  try {
    const response = await api.post('/categories', categoriaData);
    return response.data;
  } catch (error) {
    console.error('Error al crear la categoría:', error.response?.data?.message || error.message);
    throw error;
  }
};

// Actualizar una categoría existente
export const actualizarCategoria = async (id, categoriaData) => {
  try {
    const response = await api.put(`/categories/${id}`, categoriaData);
    return response.data;
  } catch (error) {
    console.error(`Error al actualizar la categoría con ID ${id}:`, error.response?.data?.message || error.message);
    throw error;
  }
};

// Eliminar una categoría
export const eliminarCategoria = async (id) => {
  try {
    const response = await api.delete(`/categories/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error al eliminar la categoría con ID ${id}:`, error.response?.data?.message || error.message);
    throw error;
  }
};
export const obtenerMetricasDashboard = async () => {
  try {
    const response = await api.get('/dashboard/metrics');
    return response.data;
  } catch (error) {
    console.error('Error al obtener métricas del dashboard:', error.response?.data?.message || error.message);
    throw error;
  }
};
// Obtener configuración del negocio
export const obtenerSettings = async () => {
  try {
    const response = await api.get('/settings');
    return response.data;
  } catch (error) {
    console.error('Error al obtener settings:', error.response?.data?.message || error.message);
    throw error;
  }
};

// Guardar configuración del negocio (requiere autenticación como admin)
export const guardarSettings = async (settingsData) => {
  try {
    const response = await api.post('/settings', settingsData);
    return response.data;
  } catch (error) {
    console.error('Error al guardar settings:', error.response?.data?.message || error.message);
    throw error;
  }
};
export const obtenerFacturas = async () => {
  try {
    const response = await api.get('/invoices');
    return response.data;
  } catch (error) {
    console.error('Error al obtener facturas:', error.response?.data?.message || error.message);
    throw error;
  }
};

export const actualizarEstadoFactura = async (id, status) => {
  try {
    const response = await api.patch(`/invoices/${id}/status`, { status });
    return response.data;
  } catch (error) {
    console.error('Error al actualizar estado de factura:', error.response?.data?.message || error.message);
    throw error;
  }
};

export const obtenerUsuarios = async () => {
  try {
    const response = await api.get('/users');
    return response.data;
  } catch (error) {
    console.error('Error al obtener usuarios:', error.response?.data?.message || error.message);
    throw error;
  }
};

export const obtenerUsuarioPorId = async (id) => {
  const res = await api.get(`/users/${id}`);
  return res.data;
};
export const actualizarUsuario = async (id, data) => {
  try {
    const response = await api.put(`/users/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error al actualizar el usuario:', error.response?.data?.message || error.message);
    throw error;
  }
};
export const eliminarUsuario = async (id) => {
  try {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al eliminar el usuario:', error.response?.data?.message || error.message);
    throw error;
  }
};